module.exports = __webpack_public_path__ + "img/font-underline.eaa49688.svg";